/*
 * @Author: liyxt
 * @Date: 2020-06-02 10:49:51
 * @LastEditors: bbqin
 * @LastEditTime: 2023-10-27 11:18:50
 * @Description: file content
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import OriginTable from 'bee-table';
import { Table as OriginTable } from '@tinper/next-ui';
import sort from './lib/sort';
import TableLocation from './lib/location';
import iconCollect from './lib/iconCollect';
//import Icon from 'bee-icon';

const { multiSelect, bigData, dragColumn, singleSelect, sum, filterColumn, singleFilter } = OriginTable;

// import bigData from 'bee-table/build/lib/bigData';
// import dragColumn from 'bee-table/build/lib/dragColumn';
// import multiSelect from 'bee-table/build/lib/multiSelect';
// import singleSelect from 'bee-table/build/lib/singleSelect';
// import sum from 'bee-table/build/lib/sum';

import { measureScrollbar } from './utils';

import {
    tinperClsPrefix,
    ajax,
    toast,
    getMultiLang,
    removeMetaCache,
    isFunction,
    PubSub,
    getGlobalStorage,
    myBrowser,
    isString,
    isNumber,
    isWrong,
    getRandom,
    getTopWindow,
} from '@platform/api';
import { createAffixScroll, affixScrollPosition } from './affixScroll';
//import Button from '../Button';
import Tooltip from '../Tooltip';
import classnames from 'classnames';
import { TableColSetting, removeTableListener } from './nc_tableColSetting';
// tinper提供的计算滚动条宽度的方法

import ColSettingSideBox from './nc_tableColSetting/colSettingSideBox';

//import 'bee-table/build/Table.css';
import './index.less';
//import '../-TableColSetting/index.less' //后面会删除

const totalDefaultHeight = 30;

// const SortTable = iconTitle(OriginTable);
const DragTable = iconCollect(dragColumn(OriginTable));
const BigDataTable = iconCollect(dragColumn(bigData(OriginTable)));

// 统一兄弟区域变化表格重新计算标识
const BEFOREAREACHANGECOMPLETE = 'beforeAreaChangeComplete';
const AREACHANGECOMPLETE = 'areaChangeComplete';
// 页面其他区域变化表格重新计算标识
const OTHERCOMPLETE = 'otherComplete';
// 高度變化
const HEIGHTTOSCROLL = 'heightToScroll';
export default class Table extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEllipsis: true,
            columns: [],
            addRightShadow: false,
            currentIndex: -1,
            bodyColumn: props.columns,
        };
        // 获取全局的个性化设置数据
        this.nccTable =
            JSON.parse(getGlobalStorage('localStorage', 'nccTable')) || {};
        // 列设置
        this.TableColSetting = TableColSetting.bind(this);
        this.removeTableListener = removeTableListener.bind(this);
        this.browser = myBrowser();
        this.usePropsColumns = true;
        this.pubsubToken = [];
        // 修改列宽标识
        this.resetWidthFlag = false;
        // 修改列设置标识
        this.resetColFlag = false;
        // 是否需要重新设置table高度
        this.resetTableHeightFlag = true;
        // 根据缓存取customer列列宽
        this.setCustomerColumnWidthFlag = true;
        // 初始化存储列表设置icon的right
        this.saveTableColSettingIconFlag = false;
    }

    UNSAFE_componentWillMount() {
        let callback = (json, bool) => {
            if (bool) {
                this.setState({ json }, () => { });
            }
        };
        getMultiLang({ moduleId: 'base_table', callback });
    }

    componentDidMount() {
        const {
            autoAffixScroll,
            adaptionHeight,
            inModal,
            cardType,
            addAffixScroll = true,
            cancelCustomRightMenu = true,
            columnWidthConfig = false,
            extendRightMenu,
            foldingRowChange,
            colsSettingParam = {},
            showFoldRow,
            addBlankCol = true, // 该属性为了取消添加空白列而设置
        } = this.props;
        //创建底部滚动条
        addAffixScroll && createAffixScroll(this);
        //创建假滚动条
        this.createFakeScroll();
        this.addScrollEvent();
        // 表格自动计算滚动条
        if (autoAffixScroll) {
            // 统一兄弟区域变化表格重新计算
            this.pubsubToken.push(
                PubSub.subscribe(AREACHANGECOMPLETE, this.affixScrollEvent),
            );
            // 监听页面其他其他变换导致表格重新计算
            this.pubsubToken.push(
                PubSub.subscribe(OTHERCOMPLETE, this.affixScrollEvent),
            );
            // 高度变化
            this.pubsubToken.push(
                PubSub.subscribe(HEIGHTTOSCROLL, this.affixScrollEvent),
            );
        }

        // 表格自适应高度
        if (adaptionHeight || inModal) {
            if (!inModal) {
                this.calculateHeight();
            }
            // 统一监听兄弟区域变化表格重新计算
            cardType &&
                this.pubsubToken.push(
                    PubSub.subscribe(
                        BEFOREAREACHANGECOMPLETE,
                        this.handlePubSubBeforeComplete,
                    ),
                );
            this.pubsubToken.push(
                PubSub.subscribe(AREACHANGECOMPLETE, this.handlePubSub),
            );
            // 监听页面其他其他变换导致表格重新计算
            this.pubsubToken.push(
                PubSub.subscribe(OTHERCOMPLETE, this.handlePubSub),
            );
            adaptionHeight &&
                window.addEventListener('resize', this.resizeListener);
            this.pubsubToken.push(
                PubSub.subscribe('MODAL', this.handlePubSubModal),
            );
        }
        // 添加空白列
        addBlankCol && this.addBlankCol();
        //列设置监听右键
        if (
            (!cancelCustomRightMenu ||
                columnWidthConfig ||
                extendRightMenu ||
                foldingRowChange) &&
            this.table
        ) {
            let { noColSetClass, colSetCallback } = colsSettingParam;
            this.TableColSetting({
                tableDom: this.table,
                noColSetClass,
                colSetCallback,
                removeCustomRightMenu: this.removeCustomRightMenu,
                showFoldRow,
                cancelCustomRightMenu: cancelCustomRightMenu,
                columnWidthConfig: columnWidthConfig,
                extendRightMenu: extendRightMenu,
            });
        }
        // 存储列表设置icon的right
        this.saveTableColSettingIcon();

        adaptionHeight && window.requestAnimationFrame(() => {
            this.calculateHeight();
        });
    }

    UNSAFE_componentWillReceiveProps(nextprops) {
        if (nextprops.rowKey === 'total-row') {
            this.setState({ bodyColumn: nextprops.columns });
            return;
        }
        const { columns = [], treeTableRef, addBlankCol = true, forceUpdateColumn = false } = nextprops;
        const { bodyColumn } = this.state;
        let { otherAreaHeight: newOtherAreaHeight } = nextprops;
        let { otherAreaHeight: oldOtherAreaHeight } = this.props;
        //当edittable浏览态编辑态切换的时候，让分页组件去掉的时候，更顺滑
        if (newOtherAreaHeight !== oldOtherAreaHeight) {
            this.calculateHeight(newOtherAreaHeight);
        }
        // 保存列宽、重置列宽、列设置保存、列设置重置  resetWidthFlag = true 传入新的columns 使用新的columns
        if (!this.resetWidthFlag) {
            // 前边四种情况都是true，只要判断下两次传进来的columns 平铺后的 attrcode是否相同
            // 当传进来新的columns列数发生变化时，resetWidthFlag设置为true，避免旧的列信息影响到新的列信息
            this.resetWidthFlag = this.compareColumns(
                columns,
                this.props.columns,
            );
        }
        if (!this.resetWidthFlag && !forceUpdateColumn) {
            this.setColumnWidth(bodyColumn, columns, treeTableRef);
        }
        if (addBlankCol) {
            this.addBlankCol([...columns]);
        } else {
            this.setState({ bodyColumn: [...columns] }, () => {
                this.resetWidthFlag = false;
            });
        }

        // 这里要重置下bodyColumn，否则排序就不好用了
    }

    componentDidUpdate(nextprops) {
        const {
            colsSettingParam = {},
            cancelCustomRightMenu = true,
            columnWidthConfig = false, // 保存列宽、重置开关
            showFoldRow = true, //控制是否显示折行控制按钮
            foldingRowChange, //点击折行的回调
            extendRightMenu,
            adaptionHeight,
            inModal = false,
            addAffixScroll = true,
        } = this.props;
        if (
            adaptionHeight &&
            !inModal &&
            nextprops.columns.length !== this.props.columns.length
        ) {
            this.calculateHeight();
        }
        addAffixScroll && createAffixScroll(this);
        this.createFakeScroll();
        this.addScrollEvent();
        this.resetColumnSettingIcon();
        //列设置监听右键
        if (
            (!cancelCustomRightMenu ||
                columnWidthConfig ||
                extendRightMenu ||
                foldingRowChange) &&
            this.table
        ) {
            let { noColSetClass, colSetCallback } = colsSettingParam;
            this.TableColSetting({
                tableDom: this.table,
                noColSetClass,
                colSetCallback,
                removeCustomRightMenu: this.removeCustomRightMenu,
                showFoldRow,
                cancelCustomRightMenu: cancelCustomRightMenu,
                columnWidthConfig: columnWidthConfig,
                extendRightMenu: extendRightMenu,
            });
        }
        showFoldRow && this.autoFoldRow();
        // 固定列阴影
        let addRightShadow = this.addRightShadow();
        if (this.state.addRightShadow !== addRightShadow) {
            this.setState({ addRightShadow });
        }
        this.resetTableHeightFlag &&
            PubSub.publishSync(BEFOREAREACHANGECOMPLETE, false);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeListener);
        // table组件销毁清空当前table内的右键菜单
        let mouseRightMenu =
            this.table &&
            this.table.querySelector('.nc-table-setColumnMenu-wrap');
        if (mouseRightMenu) {
            mouseRightMenu.parentNode.removeChild(mouseRightMenu);
        }
        this.removeScrollEvent();
        this.removeTableListener(this.removeCustomRightMenu);
        // 取消订阅
        // 按理说两个表格实例的this.affixScrollEvent不是同一个对象 但是我错了  是同一个对象
        this.pubsubToken.forEach(token => {
            PubSub.unsubscribe(token);
        });
        this.pubsubToken = [];
        this.table = null;
    }

    // 对比新旧props.columns
    compareColumns = (nextColumns, preColumns) => {
        let nextCodes = this.getAttrcodes(nextColumns).toString();
        let preCodes = this.getAttrcodes(preColumns).toString();
        return nextCodes !== preCodes;
    };

    // 拍平columns 获取columns上所有的attrcode
    getAttrcodes = columns => {
        let result = [];
        let list = [...columns];
        let currentCol;
        // eslint-disable-next-line no-cond-assign
        while ((currentCol = list.shift())) {
            result.push(
                currentCol.attrcode || currentCol.dataIndex || currentCol.key,
            );
            if (currentCol.children) {
                list.unshift(...currentCol.children);
            }
        }
        return result;
    };

    // 从state上取宽度赋给props上传入的columns
    setColumnWidth = (bodyColumn, columns, treeTableRef = undefined) => {
        bodyColumn.forEach(val => {
            columns.forEach(item => {
                if (
                    (val.attrcode &&
                        item.attrcode &&
                        val.attrcode === item.attrcode) ||
                    (val.dataIndex &&
                        item.dataIndex &&
                        val.dataIndex === item.dataIndex) ||
                    (val.key && item.key && val.key === item.key)
                ) {
                    if (
                        (treeTableRef &&
                            item.attrcode === 'checkbox_tree' &&
                            item.setFirstColWidth) ||
                        // 转单checkbox列等特殊情况需要保持外部传入的宽度更新
                        item._resetWidth
                    ) {
                        // 树表CheckBox列宽在有数据后计算出新的宽度时更新宽度使用props传进来的值
                        item.setFirstColWidth = false;
                    } else if (val.width) {
                        //解决拖拽列宽之后，查询数据setstate，防止列宽回到原来状态
                        item.width = val.width;
                    }
                }
                // 多级表头
                if (
                    val.children?.length &&
                    item.children?.length &&
                    val.dataIndex === item.dataIndex
                ) {
                    this.setColumnWidth(val.children, item.children);
                }
            });
        });
    };

    resizeListener = () => {
        this.calculateHeight();
    };

    //再次触发鼠标点击事件后移除自定义右键菜单
    removeCustomRightMenu = (ev, flag) => {
        //点击菜单
        let target = ev.target;
        //当鼠标点击的不是列宽设置外的菜单，都移除右键自定义菜单
        if (target.classList.contains('insert_number')) { return; }
        if (
            !target.classList.contains('columnWidthSetting') ||
            !target.classList.contains('insert_number') ||
            flag
        ) {
            let mouseRightMenu =
                this.table &&
                this.table.querySelector('.nc-table-setColumnMenu-wrap');
            if (mouseRightMenu) {
                mouseRightMenu.parentNode.removeChild(mouseRightMenu);
                isFunction(this.props.removeCustomRightMenu) && this.props.removeCustomRightMenu();
            }
        }
    };

    // 添加滚动事件
    addScrollEvent() {
        this.bodyAreaScroll = false;
        this.affixScrollScroll = false;
        let { autoAffixScroll } = this.props;
        let affixScroll =
            this.table && this.table.querySelector('.affix-scrollbar-wrapper');
        let bodyArea =
            this.table &&
            this.table.querySelector(`.${tinperClsPrefix}-table-body`);
        // 合计行导致固定列dom非常难取到
        let leftFixedArea = Array.from(
            (this.table &&
                this.table.querySelectorAll(
                    `.${tinperClsPrefix}-table-fixed-left .${tinperClsPrefix}-table-body-inner`,
                )) ||
            [],
        ).pop();
        let rightFixedArea = Array.from(
            (this.table &&
                this.table.querySelectorAll(
                    `.${tinperClsPrefix}-table-fixed-right .${tinperClsPrefix}-table-body-inner`,
                )) ||
            [],
        ).pop();
        bodyArea &&
            bodyArea.addEventListener('scroll', this.addBodyAreaScrollEvent);
        bodyArea &&
            bodyArea.addEventListener(
                'wheel',
                this.addBodyAreaScrollWheelEvent,
            );
        bodyArea &&
            bodyArea.addEventListener(
                'mousedown',
                this.addBodyAreaScrollWheelDownEvent,
            );
        leftFixedArea &&
            leftFixedArea.addEventListener(
                'scroll',
                this.addBodyAreaScrollEvent,
            );
        leftFixedArea &&
            leftFixedArea.addEventListener(
                'wheel',
                this.addBodyAreaScrollWheelEvent,
            );
        leftFixedArea &&
            leftFixedArea.addEventListener(
                'mousedown',
                this.addBodyAreaScrollWheelDownEvent,
            );
        rightFixedArea &&
            rightFixedArea.addEventListener(
                'scroll',
                this.addBodyAreaScrollEvent,
            );
        rightFixedArea &&
            rightFixedArea.addEventListener(
                'wheel',
                this.addBodyAreaScrollWheelEvent,
            );
        rightFixedArea &&
            rightFixedArea.addEventListener(
                'mousedown',
                this.addBodyAreaScrollWheelDownEvent,
            );
        affixScroll &&
            affixScroll.addEventListener(
                'scroll',
                this.addAffixScrollScrollEvent,
            );
        autoAffixScroll && this.addParentScorllerEvent();
    }

    // 去除滚动事件
    removeScrollEvent() {
        this.bodyAreaScroll = false;
        this.affixScrollScroll = false;

        let affixScroll =
            this.table && this.table.querySelector('.affix-scrollbar-wrapper');
        let bodyArea =
            this.table &&
            this.table.querySelector(`.${tinperClsPrefix}-table-body`);
        let leftFixedArea = Array.from(
            (this.table &&
                this.table.querySelectorAll(
                    `.${tinperClsPrefix}-table-fixed-left .${tinperClsPrefix}-table-body-inner`,
                )) ||
            [],
        ).pop();
        let rightFixedArea = Array.from(
            (this.table &&
                this.table.querySelectorAll(
                    `.${tinperClsPrefix}-table-fixed-right .${tinperClsPrefix}-table-body-inner`,
                )) ||
            [],
        ).pop();
        bodyArea &&
            bodyArea.removeEventListener('scroll', this.addBodyAreaScrollEvent);
        bodyArea &&
            bodyArea.removeEventListener(
                'wheel',
                this.addBodyAreaScrollWheelEvent,
            );
        bodyArea &&
            bodyArea.removeEventListener(
                'mousedown',
                this.addBodyAreaScrollWheelDownEvent,
            );
        leftFixedArea &&
            leftFixedArea.removeEventListener(
                'scroll',
                this.addBodyAreaScrollEvent,
            );
        leftFixedArea &&
            leftFixedArea.removeEventListener(
                'wheel',
                this.addBodyAreaScrollWheelEvent,
            );
        leftFixedArea &&
            leftFixedArea.removeEventListener(
                'mousedown',
                this.addBodyAreaScrollWheelDownEvent,
            );
        rightFixedArea &&
            rightFixedArea.removeEventListener(
                'scroll',
                this.addBodyAreaScrollEvent,
            );
        rightFixedArea &&
            rightFixedArea.removeEventListener(
                'wheel',
                this.addBodyAreaScrollWheelEvent,
            );
        rightFixedArea &&
            rightFixedArea.removeEventListener(
                'mousedown',
                this.addBodyAreaScrollWheelDownEvent,
            );
        affixScroll &&
            affixScroll.removeEventListener(
                'scroll',
                this.addAffixScrollScrollEvent,
            );
        this.removeParentScorllerEvent();
    }

    addAffixScrollScrollEvent = () => {
        if (this.bodyAreaScroll == true) {
            this.bodyAreaScroll = false;
            return;
        }
        let totalArea =
            this.table &&
            this.table.querySelector(
                `.total-row .${tinperClsPrefix}-table-body`,
            );
        let affixScroll =
            this.table && this.table.querySelector('.affix-scrollbar-wrapper');
        let bodyArea =
            this.table &&
            this.table.querySelector(`.${tinperClsPrefix}-table-body`);
        this.affixScrollScroll == true;
        // 表体滚动条事件
        // if (totalArea && affixScroll) totalArea.scrollLeft = affixScroll.scrollLeft;
        bodyArea && (bodyArea.scrollLeft = affixScroll.scrollLeft);
        // console.log('addAffixScrollScrollEvent trigger');
        this.bodyAreaScroll = false;
    };
    addBodyAreaScrollEvent = e => {
        if (this.affixScrollScroll == true) {
            this.affixScrollScroll = false;
            return;
        }
        let totalArea =
            this.table &&
            this.table.querySelector(
                `.total-row .${tinperClsPrefix}-table-body`,
            );
        let bodyArea =
            this.table &&
            this.table.querySelector(`.${tinperClsPrefix}-table-body`);
        let affixScroll =
            this.table && this.table.querySelector('.affix-scrollbar-wrapper');
        // console.log(444,this.table)
        this.bodyAreaScroll = true;
        // 表体滚动条事件
        // if (totalArea) totalArea.scrollLeft = bodyArea.scrollLeft;
        if (affixScroll) { affixScroll.scrollLeft = bodyArea.scrollLeft; }
        this.affixScrollScroll = false;
    };

    addBodyAreaScrollWheelDownEvent = event => {
        // 鼠标中键按下
        if (event.buttons === 4) {
            let bodyArea =
                this.table &&
                this.table.querySelector(`.${tinperClsPrefix}-table-body`);
            event.stopPropagation();
            bodyArea.contains(event.target) && event.preventDefault();
        }
    };

    addBodyAreaScrollWheelEvent = event => {
        let { currentTarget, deltaX, deltaY } = event;
        // if (Math.abs(deltaX) > Math.abs(deltaY)) {
        //     currentTarget.scrollLeft = currentTarget.scrollLeft + deltaX;
        // }
        // 不用管X，不然会出现滚动条消失的BUG
        if (Math.abs(deltaX) < Math.abs(deltaY)) {
            console.log('wheel trigger');
            try {
                let $parentElement = currentTarget,
                    $scrollElement = null;
                while ($parentElement) {
                    let overflow = window
                        .getComputedStyle($parentElement)
                        .getPropertyValue('overflow-y');
                    // 由于dom变化  可能会导致本来没有滚动条的产生滚动条  所以所有dom都要加下这个逻辑
                    if (
                        $parentElement.scrollHeight >
                        $parentElement.clientHeight &&
                        overflow == 'auto'
                    ) {
                        $scrollElement = $parentElement;
                        break;
                    }

                    $parentElement = $parentElement.parentElement;
                    // parent 目前不做处理  不再循环  让bottom为0
                    if ($parentElement === document.body) {
                        $scrollElement = null;
                        break;
                    }
                }
                if ($scrollElement) {
                    event.preventDefault();
                    window.updateTrigger = true;

                    let scrollLen = $scrollElement.scrollTop + deltaY;

                    if (scrollLen >= 0 && scrollLen < $scrollElement.scrollHeight - $scrollElement.offsetHeight) {
                        event.stopPropagation();
                    }

                    $scrollElement.scrollTop =
                        $scrollElement.scrollTop + deltaY;

                    // currentTarget.parentNode.scrollTop = $scrollElement.parentNode.scrollTop + deltaY;
                    window.requestAnimationFrame(() => {
                        console.log('updateTrigger');
                        window.updateTrigger = false;
                    });
                } else {
                    window.updateTrigger = false;
                }
            } catch (error) {
                console.error(error);
                window.updateTrigger = false;
            }
        }
    };

    affixScrollEvent = () => {
        let affixScroll =
            this.table && this.table.querySelector('.affix-scrollbar-wrapper');
        if (!affixScroll) {
            return;
        }
        affixScrollPosition(this);
    };

    // 判断是否有在保存列宽时缓存的customer列的数据，如果有使用缓存
    setCustomerColumnWidth = bodyColumn => {
        let { colsSettingParam } = this.props;
        if (!colsSettingParam) { return; }
        let { appcode, pagecode, areaCode } = colsSettingParam;
        let userDataJSON = getGlobalStorage('localStorage', 'STOREFORINFODATA');
        let userData = userDataJSON && JSON.parse(userDataJSON);
        let userid = userData && userData.userId;
        let customer_column_localStorage =
            'customer_col_width_' +
            appcode +
            '_' +
            pagecode +
            '_' +
            areaCode +
            '_' +
            userid;
        let customerColumns =
            JSON.parse(
                getGlobalStorage('localStorage', customer_column_localStorage),
            ) || [];
        if (customerColumns.length) {
            bodyColumn.map(item => {
                customerColumns.map(ele => {
                    if (item.attrcode === ele.attrcode) {
                        item.width = ele.width;
                    }
                    return ele;
                });
                return item;
            });
        }
    };

    // 列设置图标遮挡表头文字
    resetBodyColumn = (addBlankCol, bodyColumn) => {
        let length = bodyColumn.length - 1;
        if (this.haveHorizontalScrollBar()) {
            length = addBlankCol
                ? bodyColumn.length - 2
                : bodyColumn.length - 1;
        }
        bodyColumn.map((item, index) => {
            if (index === length) {
                item.className = item.className
                    ? item.className.includes('last-column-setting')
                        ? item.className
                        : (item.className += ' last-column-setting ')
                    : ' last-column-setting ';
            } else {
                item.className = item.className
                    ? item.className.replace(/last-column-setting/g, '')
                    : ' ';
            }
            return item;
        });
    };

    // 保存列设置图标的right值
    saveTableColSettingIcon = () => {
        let { colsSettingParam } = this.props;
        if (!colsSettingParam) { return; }
        if (!this.saveTableColSettingIconFlag && this.tableColSettingIcon) {
            let iconRight = 0;
            if (this.tableColSettingIcon.currentStyle) {
                iconRight = this.tableColSettingIcon.currentStyle[
                    'right'
                ].replace('px', '');
            } else {
                iconRight = window
                    .getComputedStyle(this.tableColSettingIcon)
                ['right'].replace('px', '');
            }
            let scrollbarWidth = measureScrollbar();
            this.iconRightValue = iconRight;
            this.iconRightScrollValue =
                Number(iconRight) + Number(scrollbarWidth);
            this.saveTableColSettingIconFlag = true;
        }
    };

    // table 更新结束判断是否需要重新设置列表设置图标的样式
    resetColumnSettingIcon = () => {
        let { colsSettingParam } = this.props;
        if (!colsSettingParam) { return; }
        let iconRight = 0;
        if (this.haveVerticalScrollBar()) {
            iconRight = this.iconRightScrollValue;
        } else {
            iconRight = this.iconRightValue;
        }
        this.tableColSettingIcon &&
            (this.tableColSettingIcon.style.right = iconRight + 'px');
    };

    // 判断是否有横向滚动条
    haveHorizontalScrollBar = () => {
        let outBody =
            this.table &&
            this.table.querySelector(`.base-table-body-scroll-wrapper`);
        if (!outBody) { return false; }
        let overflow =
            outBody &&
            window.getComputedStyle(outBody).getPropertyValue('overflow');
        let overflowX =
            outBody &&
            window.getComputedStyle(outBody).getPropertyValue('overflow-X');
        let isOverFlow =
            outBody.scrollWidth - outBody.offsetWidth > 1 &&
            (overflow == 'auto' ||
                overflowX == 'scroll' ||
                overflowX == 'auto');
        return isOverFlow;
    };

    // 判断是否有纵向滚动条，如果有纵向滚动条，需要重新设置列表设置的right值
    haveVerticalScrollBar = () => {
        let { cancelCustomRightMenu = true } = this.props;
        if (cancelCustomRightMenu) {
            return;
        }
        let outbody =
            this.table &&
            this.table.querySelector(`.${tinperClsPrefix}-table-body`);
        if (outbody) {
            let innerbody = outbody.querySelector('table');
            if (innerbody) {
                return innerbody.offsetHeight > outbody.offsetHeight;
            } else {
                return false;
            }
        }
    };

    // 固定滚动条的窗口改变计算
    addResizeEvent = () => {
        let { addAffixScroll = true, cardType } = this.props;
        addAffixScroll && createAffixScroll(this);
        this.affixScrollEvent();
    };

    // 给父级可滚动元素添加事件
    addParentScorllerEvent() {
        if (!this.table) { return; }
        let $parentElement = this.table.parentElement;
        while ($parentElement) {
            $parentElement.addEventListener('scroll', this.affixScrollEvent);
            if ($parentElement === document.body) {
                document.addEventListener('scroll', this.affixScrollEvent);
                break;
            }
            $parentElement = $parentElement.parentElement;
        }
    }

    removeParentScorllerEvent() {
        if (!this.table) { return; }

        let $parentElement = this.table.parentElement;
        while ($parentElement && $parentElement !== document.body) {
            $parentElement.removeEventListener('scroll', this.affixScrollEvent);
            $parentElement = $parentElement.parentElement;
        }
        document.body.removeEventListener('scroll', this.affixScrollEvent);
        document.removeEventListener('scroll', this.affixScrollEvent);
        window.removeEventListener('resize', this.addResizeEvent);
    }

    //折行
    autoFoldRow = () => {
        const {
            colsSettingParam = {},
            cancelCustomRightMenu = true,
            columnWidthConfig = false, //
            foldingRowChange, //点击折行的回调
            foldCacheId, //对于没有appcode，pagecode..的表格，做折行缓存的标志
            extendRightMenu,
        } = this.props;
        if (
            !cancelCustomRightMenu ||
            columnWidthConfig ||
            extendRightMenu ||
            foldingRowChange
        ) {
            let { appcode, pagecode, areaCode } = colsSettingParam;

            let userDataJSON = getGlobalStorage(
                'localStorage',
                'STOREFORINFODATA',
            );
            let userData = userDataJSON && JSON.parse(userDataJSON);
            let userid = userData && userData.userId;

            if (appcode && pagecode && areaCode) {
                this.fold_localStorage =
                    'foldFlag_' +
                    appcode +
                    '_' +
                    pagecode +
                    '_' +
                    areaCode +
                    '_' +
                    userid;
            } else {
                this.fold_localStorage = foldCacheId + '_' + userid;
            }
            if (this.fold_localStorage) {
                let fold_flag =
                    getGlobalStorage('localStorage', 'fold_flag') || {};
                if (typeof fold_flag === 'string') {
                    fold_flag = JSON.parse(fold_flag);
                }
                let flag = fold_flag[this.fold_localStorage];
                let isEllipsis = flag !== 'isFold';
                if (
                    isEllipsis === false &&
                    this.state.isEllipsis !== isEllipsis
                ) {
                    this.setState({ isEllipsis });
                    isFunction(foldingRowChange) &&
                        foldingRowChange(isEllipsis);
                }
            }
        }
    };

    // 无数据样式（暂无数据）
    noData = () => {
        let { json = {}, tableHeight } = this.state;
        let { adaptionHeight, bodyStyle = {} } = this.props;
        let topValue = '53%';
        if (this.table) {
            // let headerDom = this.table.querySelectorAll(`.${tinperClsPrefix}-table-thead`)[0];
            let headerDom = this.table.querySelectorAll(`thead`)[0];
            let headerHeight = 28;
            if (headerDom) {
                headerHeight = headerDom.offsetHeight;
            }
            headerHeight = headerHeight > 300 ? 28 : headerHeight;

            if (adaptionHeight) {
                topValue = tableHeight / 2 + headerHeight - 13;
            } else {
                let { minHeight, height } = bodyStyle;

                if (height) {
                    if (isString(height)) {
                        height = Number(height.replace(/px/, ''));
                    }
                    topValue = height / 2 + headerHeight - 13;
                } else if (minHeight) {
                    if (isString(minHeight)) {
                        minHeight = Number(minHeight.replace(/px/, ''));
                    }
                    topValue = minHeight / 2 + headerHeight - 13;
                }
            }
            if (isNaN(topValue)) {
                topValue = '53%';
            }
            if (isNumber(topValue)) {
                topValue += 'px';
            }
            let nodataDom = this.table.querySelector(`.base-table-empty-text`);
            if (nodataDom) {
                nodataDom.setAttribute(
                    'style',
                    `position: absolute; left: 50%; width: 200px; margin-left: -100px;border: none;height: auto;top: ${String(
                        topValue,
                    )};`,
                );
            }
        }

        let { minHeight, height } = bodyStyle;

        return (
            <div className="no-data-placeholder">
                <i className="no-data" />
                <span className="no-data-title">{json['base-table-0001']}</span>
            </div>
        );
    };

    // 表格之外其他区域变化高度回调
    handlePubSub = (msg, data) => {
        let { inModal } = this.props;
        if (data) {
            // 计算表格高度, 延遲200毫秒，等待其他區域加載完再進行計算  // 去除
            // setTimeout(() => {
            if (!inModal) {
                this.calculateHeight();
            }
            // }, 0);
        }
    };

    handlePubSubModal = (msg, data) => {
        // 其他区域高度
        let { otherAreaHeight = 0 } = this.props;
        //模态框下方的表格，模态框拖拽时，使表格高度自适应
        if (data.sence === 'modal' && data.currentModal && this.props.inModal) {
            let modalBody = data.currentModal.querySelector(
                `.${tinperClsPrefix}-modal-body`,
            );
            let ncTableDom = ReactDOM.findDOMNode(this);
            if (modalBody && modalBody.contains(ncTableDom)) {
                this.resizeModal = true;
                let bodyTop = modalBody.getBoundingClientRect().top;
                let bodyHeight = modalBody.offsetHeight;
                const paddingBottom = Number(
                    this.getStyle(modalBody, 'paddingBottom').replace('px', ''),
                );
                let tableTop = ncTableDom.getBoundingClientRect().top;
                // 合计行表格高度
                let totalHeight = this.props.isTotal ? totalDefaultHeight : 0;
                if (
                    this.props.isTotal &&
                    (this.browser == 'IE' ||
                        this.browser == 'Firefox' ||
                        this.browser == 'Edge')
                ) {
                    totalHeight = 47;
                }
                // 表头高度
                const headerHeight = ncTableDom.querySelectorAll(
                    `.${tinperClsPrefix}-table-thead`,
                )[0].offsetHeight;
                // 某些情况下，出现scroll.y为负数导致数据不能渲染的情况
                let tableHeight =
                    bodyHeight -
                    (tableTop - bodyTop) -
                    headerHeight -
                    totalHeight -
                    paddingBottom -
                    otherAreaHeight -
                    2;
                // 计算表格距离body位置
                //console.log("表格高度计算---tableHeight:", tableHeight, 'tableTop:', tableTop, 'bodyTop:', bodyTop, 'bodyHeight:', bodyHeight, 'totalHeight==', totalHeight, 'headerHeight====', headerHeight, 'paddingBottom==', paddingBottom, 'otherAreaHeight:', otherAreaHeight);
                this.setState({ tableHeight: tableHeight < 0 ? 210 : tableHeight });
            }
        }
    };

    handlePubSubBeforeComplete = (msg, isSetAbsolute) => {
        if (!this.table) { return; }
        // 在modal内部的table不需要进入这个逻辑，应该在resize进入handlePubSubModal
        let { inModal } = this.props;
        if (inModal) { return; }
        let { tableHeight } = this.state;
        let { newTableHeight } = this.calculateNewTableHeight();
        let resetTableHeightFlag = false;
        if (newTableHeight) {
            // 如果其他区域的变化没有影响到table，那么不需要重新计算高度
            resetTableHeightFlag = tableHeight == newTableHeight;
        }
        let wrapEl = this.table.parentElement;
        let parentEl = wrapEl.parentElement;
        let parentHeight = parentEl.offsetHeight;
        let buoy = '';
        if (tableHeight > 210) {
            buoy = [
                'position: absolute',
                'left: 0',
                'right: 0',
                // 'top: 0',
                'bottom: 0',
                'overflow: hidden',
                'z-index: 1',
            ];
            // 如果父节点没有高度，设置padding为0
            parentHeight > 0
                ? buoy.push('padding:4px 8px 0 8px')
                : buoy.push('padding: 0');
            buoy.join(';');
        }
        if (resetTableHeightFlag) {
            wrapEl.removeAttribute('style');
        } else if (isSetAbsolute) {
            wrapEl.setAttribute('style', buoy);
        } else {
            wrapEl.removeAttribute('style');
        }
    };

    // 计算表格新的高度
    calculateNewTableHeight = newOtherAreaHeight => {
        if (!this.table) {
            return;
        }
        let wrapEl = this.table.parentElement.parentElement.parentElement;
        let parentEl = wrapEl.parentElement;
        let { cardType, isTotal, otherAreaHeight, currentIndex } = this.props;
        if (newOtherAreaHeight || newOtherAreaHeight === 0) {
            otherAreaHeight = newOtherAreaHeight;
        }
        // 合计行表格高度
        let totalHeight = isTotal ? totalDefaultHeight : 0;
        if (
            isTotal &&
            (this.browser == 'IE' ||
                this.browser == 'Firefox' ||
                this.browser == 'Edge')
        ) {
            totalHeight = 47;
        }
        /**
         * 表头高度
         * 对表头高度获取错误的情况做一下兼容,错误的时候取到的是表体高度
         * 目前只有树表有这种情况,所以只兼容单表头情况,等想到好办法在改一下这里
         */
        let headerDom = this.table.querySelectorAll(
            `.${tinperClsPrefix}-table-thead`,
        )[0];

        let headerHeight = 28;
        if (headerDom) {
            headerHeight = headerDom.offsetHeight;
        }
        headerHeight = headerHeight > 300 ? 28 : headerHeight;
        // 表格下方其他部分高度
        otherAreaHeight = otherAreaHeight || 0;
        let tableBody = this.table.querySelectorAll(
            `.${tinperClsPrefix}-table-content`,
        )[0];
        const paddingBottom = Number(
            this.getStyle(document.body, 'paddingBottom').replace('px', ''),
        );
        let top;
        if (cardType) {
            top = parentEl.getBoundingClientRect().top;
        } else {
            top = this.table.getBoundingClientRect().top;
        }

        let newTableHeight = null;
        // 其他表格都是会多出页面头部的一部分存在外层window的时候，所以这里直接取里层的高度了，card除外所以另外处理
        // let windowHeight = document.documentElement.clientHeight;
        let windowHeight = document.body.clientHeight;
        if (top && tableBody) {
            newTableHeight =
                windowHeight -
                paddingBottom -
                top -
                headerHeight -
                totalHeight -
                otherAreaHeight -
                3;
            // 对cardtable的专有判断, card布局有特殊情况,需要多减8
            if (cardType === 'card' && getTopWindow()) {
                newTableHeight = newTableHeight - 2;
            }
            let hasIndexTr = tableBody.querySelectorAll(
                `.${tinperClsPrefix}-table-body tr[data-row-index]`,
            );
            let lastIndexTr = hasIndexTr && hasIndexTr[hasIndexTr.length - 1];
            currentIndex =
                currentIndex >= 0
                    ? currentIndex
                    : lastIndexTr
                        ? Number(lastIndexTr.getAttribute('data-row-index')) / 2 - 1
                        : -1;
            tableBody = null;
            //表格最小高度210px
            if (newTableHeight < 210) {
                newTableHeight = 210;
            }
            return { newTableHeight, currentIndex };
        } else {
            return {};
        }
    };

    // 高度自适应计算
    calculateHeight = newOtherAreaHeight => {
        let { otherAreaHeight } = this.props;
        if (newOtherAreaHeight || newOtherAreaHeight === 0) {
            otherAreaHeight = newOtherAreaHeight;
        }
        let { newTableHeight, currentIndex } =
            this.calculateNewTableHeight(otherAreaHeight);
        if (newTableHeight) {
            this.setState(
                {
                    tableHeight: newTableHeight,
                    currentIndex: Math.floor(currentIndex),
                },
                () => {
                    PubSub.publishSync(BEFOREAREACHANGECOMPLETE, false);
                },
            );
        }
    };

    // 获取元素的样式属性值
    getStyle = (obj, attr) => {
        if (obj.currentStyle) {
            return obj.currentStyle[attr];
        } else {
            return document.defaultView.getComputedStyle(obj, null)[attr];
        }
    };

    // 获取表格的行高
    getRowHeight = tableType => {
        switch (tableType) {
            case 'compact':
                return 24;
            case 'standard':
                return 28;
            case 'loose':
                return 36;
        }
    };

    // 平铺columns
    getArrColumn = (columns, newColumns) => {
        columns.forEach(item => {
            if (item.children) {
                this.getArrColumn(item.children, newColumns);
            } else {
                newColumns.push(item);
            }
        });
    };

    //空白列
    addBlankCol = bodyColumn => {
        if (bodyColumn === undefined) {
            bodyColumn = this.state.bodyColumn || [];
        }
        let blankrowFlag = true;
        if (bodyColumn.length && this.table) {
            bodyColumn.forEach(element => {
                if (element.attrcode == 'blankrow') {
                    blankrowFlag = false;
                }
            });
            if (blankrowFlag) {
                let obj = {
                    title: <div className={'fake-line'} />,
                    key: 'blankrow',
                    dataIndex: 'blankrow',
                    attrcode: 'blankrow',
                    className: 'blankrow',
                    visible: true,
                    itemtype: 'customer',
                    width: '1px',
                    render: () => <div />,
                };
                bodyColumn.push(obj);
            }
        }
        this.setState({ bodyColumn }, () => {
            this.resetWidthFlag = false;
        });
    };
    // 冻结列
    freezeColumns = columns => {
        columns.map(item => {
            if (item.islock && !item.fixed) {
                item.fixed = 'left';
            }
            return item;
        });
    };
    onDraggingBorder = (e, width, column, columns) => {
        if (this.table && !this.draggingBorder) {
            this.draggingBorder = true;
            this.table.className += ' dragging-border-temp ';
        }
        if (this.props.onDraggingBorder) {
            this.props.onDraggingBorder(e, width, column, columns);
        }
        this.createFakeScroll(true);
    };

    onDropBorder = (e, width, column, dropColumns) => {
        if (this.table) {
            this.draggingBorder = false;
            this.table.className = this.table.className.replace(
                /dragging-border-temp/gi,
                '',
            );
        }
        const { onDropBorderHandler, treeTableRef } = this.props;
        const { bodyColumn } = this.state;
        if (treeTableRef) {
            let index = bodyColumn.findIndex(
                item => item.setFirstColWidth === true,
            );
            if (index > -1) {
                bodyColumn[index]['resetWidth'] = true;
                if (column?.attrcode === dropColumns[0].attrcode) {
                    onDropBorderHandler && onDropBorderHandler(width, column);
                }
            }
        }
        this.setColumnWidth(dropColumns, bodyColumn);
        // 拖拽列宽之后不再从缓存里读取customer
        this.setCustomerColumnWidthFlag = false;
        // 拖拽列宽不会进入 willreceiveProps
        this.setState({ bodyColumn: bodyColumn }, () => {
            // table渲染完成后获取最新的列宽修改合计行的列宽
            onDropBorderHandler && onDropBorderHandler(width, column);
        });
    };

    createFakeScroll = isDropBorder => {
        const { isTotal, data, createFakeScroll = true } = this.props;
        if (!createFakeScroll) {
            return;
        }
        // let { minHeight } = bodyStyle;
        let tableHaveData = Array.isArray(data) && data.length;
        let flag = false;
        //解决NCCLOUD-189979问题
        let bodyHeight = 60;
        if (this.table) {
            // 解决ie下tbody 没有宽度的问题
            let tableHeaderCenter = this.table.querySelector(
                `.${tinperClsPrefix}-table-header table`,
            );
            let tableCenter = this.table.querySelector(
                `.${tinperClsPrefix}-table-body`,
            );
            if (tableCenter && tableHeaderCenter) {
                let scrollWidth =
                    tableHeaderCenter.getBoundingClientRect().width; //u-table-body 下 table标签宽度
                let fakeScroll = this.table.querySelector('.fake-scrollbar');
                //判断假滚动条是否是当前表格的子元素
                let isChildScroll = fakeScroll === tableCenter.lastChild;
                //没数据 没假滚动条
                if (!tableHaveData && !fakeScroll) {
                    flag = true;
                    //没数据 拖拽列宽
                } else if (!tableHaveData && isDropBorder) {
                    flag = true;

                    //有假滚动条 没数据
                } else if (fakeScroll && !tableHaveData && isChildScroll) {
                    if (fakeScroll.offsetWidth === scrollWidth) {
                        return;
                    }
                    flag = true;
                    tableCenter.removeChild(fakeScroll);
                    //有假滚动条 有数据 去掉假滚动条
                } else if (fakeScroll && tableHaveData && isChildScroll) {
                    //有数据 去掉假滚动条
                    tableCenter.removeChild(fakeScroll);
                }
                if (flag) {
                    let fixheight = 20;
                    // if (this.myBrowser == 'IE' || this.myBrowser == 'Firefox') {
                    //     fixheight = 28;
                    // }
                    let top = bodyHeight - fixheight;
                    if (scrollWidth) {
                        if (isDropBorder) {
                            fakeScroll.setAttribute(
                                'style',
                                `top:${top}px;width:${scrollWidth}px`,
                            );
                        } else {
                            let div = document.createElement('div');
                            if (isTotal) {
                                div.setAttribute(
                                    'class',
                                    'fake-scrollbar fake-scrollbar-transparent',
                                );
                            } else {
                                div.setAttribute('class', 'fake-scrollbar');
                            }
                            div.setAttribute(
                                'style',
                                `top:${top}px;width:${scrollWidth}px`,
                            );
                            tableCenter.appendChild(div);
                        }
                    }
                }
            }
        }
    };

    addRightShadow = () => {
        let tablebody =
            this.table &&
            this.table.querySelector(`.${tinperClsPrefix}-table-body table`);
        if (tablebody) {
            let haveScrollbar = tablebody.scrollWidth > tablebody.offsetWidth;
            return haveScrollbar;
        }
    };
    // 拍平数组
    getFlatArr(arr) {
        let result = [];
        let list = [...arr];
        let currentCol;
        // eslint-disable-next-line no-cond-assign
        while ((currentCol = list.shift())) {
            result.push(currentCol);
            if (currentCol.children) {
                list.unshift(...currentCol.children);
            }
        }
        return result;
    }

    // 获取所有的非一级表头
    getChildrenColumns(columns) {
        let result = this.getFlatArr(columns);
        let newColumns = [];
        result.map(item => {
            item._level > 1 && newColumns.push(item.attrcode);
            return item;
        });
        return newColumns;
    }

    //删除列里可能包含虚拟dom的字段
    deleteVDom = col => {
        let excludeVDom = Object.assign({}, col);
        delete excludeVDom.title;
        delete excludeVDom.sorter;
        delete excludeVDom.render;
        delete excludeVDom.width;
        return excludeVDom;
    };

    //发送请求获取模板取title 执行保存callback
    getColIncludeTitle = (isAsync = true, includeChildren = true, callback) => {
        let { colsSettingParam } = this.props;
        const { bodyColumn } = this.state;
        let newColumns = bodyColumn.filter(
            val => val.itemtype !== 'customer',
        );
        //tableType:是什么高阶表格
        //tabName:cardtable的页签名字
        let {
            appcode,
            pagecode,
            code,
            pageid,
            areaCode,
            tableType,
            tabName,
            hiddenLeftItem,
        } = colsSettingParam;
        let finalAreaCode = areaCode;
        //用于兼容cardtable多页签
        if (tableType === 'cardtable' && tabName) {
            finalAreaCode = tabName;
        }
        ajax({
            url: '/nccloud/platform/template/getUserTemplateMap.do',
            async: isAsync,
            data: {
                appcode,
                pagecode,
                templatecode: code,
                templateId: pageid,
            },
            success: res => {
                // 获取左侧模板全部数据
                let areaList = res.data[0].areas;
                //获取右侧表格显示数据
                let rightData = res.data[1][finalAreaCode].items;
                let items = areaList[finalAreaCode].items;
                let cols =
                    items &&
                    items.map(val => {
                        val.title = val.label || val.display || val.value;
                        val.attrcode = val.code;
                        return val;
                    });
                let columnsHaveTitle = cols.filter(val => {
                    if (hiddenLeftItem && hiddenLeftItem.length) {
                        return (
                            val.visible === true &&
                            !hiddenLeftItem.includes(val.attrcode)
                        );
                    } else {
                        return val.visible === true;
                    }
                });

                //是否有自定义项
                let flag = newColumns.length !== items.length;
                let userDefineItems = [];
                if (flag) {
                    let rightAttrcode = newColumns.map(item => item.attrcode);
                    cols.map(item => {
                        if (
                            rightAttrcode.includes(item.attrcode) &&
                            item.visible === false
                        ) {
                            userDefineItems.push(item);
                        }
                        return item;
                    });
                }
                if (flag) {
                    newColumns.map((val, index) => {
                        userDefineItems.map(item => {
                            if (item.attrcode === val.attrcode) {
                                columnsHaveTitle.splice(index, 0, item);
                            }
                            return item;
                        });
                        return val;
                    });
                }

                // 如果不需要包含二级表头，那就把二级表头过滤掉
                if (!includeChildren) {
                    // 拿出来所有的二级表头
                    let childrenColumns = this.getChildrenColumns(newColumns);
                    // 筛选出一级表头的列
                    columnsHaveTitle = columnsHaveTitle.filter(item => {
                        return childrenColumns.indexOf(item.attrcode) == -1;
                    });
                }
                this.setState(
                    {
                        columnsHaveTitle,
                        rightData,
                        userDefineItems,
                    },
                    () => {
                        if (typeof callback === 'function') { callback(columnsHaveTitle, items); }
                    },
                );
            },
            error: err => {
                this.onRequestError(err);
            },
        });
    };

    // 显示侧拉，获取columns
    toShowDrawer = () => {
        let { colsSettingParam } = this.props;
        let { bodyColumn } = this.state;
        if (colsSettingParam) {
            //支持列设置的表格，从props取模板信息；取不到之后再发向后端获取
            if (bodyColumn) {
                let { hiddenLeftItem } = colsSettingParam;
                let newColumns = bodyColumn.filter(val => {
                    if (hiddenLeftItem?.length) {
                        // 业务组会隐藏某些列
                        //changeMetaCol为了解决NCC-43188，改了模板，把itemtype改成customer
                        return (
                            (val.itemtype !== 'customer' ||
                                val.changeMetaCol === true) &&
                            !hiddenLeftItem.includes(val.attrcode) &&
                            !val.children
                        );
                    } else {
                        return (
                            (val.itemtype !== 'customer' ||
                                val.changeMetaCol === true) &&
                            !val.children
                        );
                    }
                });
                newColumns.forEach(val => {
                    val.width = String(val.width);
                    val.visible = true;
                    val.isLock = val.fixed === 'left';
                    if (val.fixed) { delete val.fixed; }
                });
                this.sortData = [...newColumns];
                this.getColIncludeTitle(true, false, leftItems => {
                    //列设置
                    let userItems = this.state.userDefineItems.map(
                        item => item.attrcode,
                    );
                    let rightItems = this.state.rightData.filter(
                        item => item.visible !== false,
                    );
                    let newLeftItems = leftItems.map(val => {
                        //右侧已经存在则将左侧字段隐藏
                        val.showItem = true;
                        rightItems.map((item, index) => {
                            if (item.attrcode == val.attrcode) {
                                if (item.visible === true) {
                                    val.showItem = false;
                                }
                                if (userItems.includes(val.attrcode)) {
                                    val.showItem = false;
                                    rightItems[index].noDeletion = true;
                                }
                            }
                            return item;
                        });
                        return val;
                    });

                    this.setState({
                        displayData: [...newLeftItems],
                        sortData: [...rightItems],
                        showDrawer: true,
                    });
                });
                //   }
                // );
            }
        }
    };

    //关闭侧拉
    toCloseDrawer = () => {
        this.setState({ showDrawer: false });
    };

    //点击侧拉header的确定按钮
    onColsSetting = sortData => {
        let { columnsHaveTitle, json = {} } = this.state;
        let metaColums = [],
            ajaxColums = [];
        // 重新设置列设置 添加重置列宽的标识
        // this.resetWidthFlag = true
        sortData.map(val => {
            let { width, attrcode } = val;
            //前端默认拼的120默认宽度不保存到后端
            let ajaxWidthNS, metaWidthNS, title, propertyId;
            if (typeof width === 'string') {
                ajaxWidthNS = width.match(/\d+/g)[0];
                metaWidthNS = width.match(/\d+/g)[0];
            }
            // 后端不需要120px 前端需要
            if (ajaxWidthNS && (ajaxWidthNS == 120 || ajaxWidthNS == '120')) {
                ajaxWidthNS = undefined;
            }
            columnsHaveTitle.forEach(item => {
                if (attrcode === item.code) {
                    title = item.title;
                    propertyId = item.attrcode;
                }
            });
            let ajaxWidthObj = ajaxWidthNS ? { width: ajaxWidthNS } : {};
            let metaWidthObj = metaWidthNS
                ? { width: Number(metaWidthNS) }
                : {};
            let enableCol = this.deleteVDom(val);

            metaColums.push({
                ...enableCol,
                // propertyId,
                ...metaWidthObj,
                label: title,
                title,
                islock: val.islock ? val.islock : false,
            });
            ajaxColums.push({
                ...enableCol,
                // propertyId,
                ...ajaxWidthObj,
                label: title,
                title,
                islock: val.islock ? val.islock : false,
            });
            return val;
        });
        let { rightData } = this.state;

        let ajaxItems = [];

        ajaxColums.forEach((ajaxItem, ajaxIndex) => {
            let oldItem = rightData.find(item => item.attrcode === ajaxItem.attrcode);
            ajaxItems[ajaxIndex] = { ...oldItem, ...ajaxItem };
            oldItem.isLoop = true;
        });
        rightData.forEach(item => {
            if (item.isLoop) {
                delete item.isLoop;
            } else {
                ajaxItems.push(item);
            }
        });

        this.onSave(metaColums, ajaxItems, json['table_colseting_tip02']); //'列设置保存成功'
    };

    //保存列设置或者保存列宽的请求
    onSave = (metaColumns, ajaxColums, successSMG) => {
        let { colsSettingParam } = this.props;
        let {
            appcode,
            pagecode,
            code,
            pageid,
            areaCode,
            areaId,
            tableType,
            tabName,
        } = colsSettingParam;
        let finalAreaCode = areaCode;
        //用于兼容cardtable多页签
        if (tableType === 'cardtable' && tabName) {
            finalAreaCode = tabName;
        }
        ajax({
            url: '/nccloud/platform/template/propertySetting.do',
            data: {
                appcode,
                pagecode,
                templatecode: code,
                templateId: pageid,
                [finalAreaCode]: {
                    areaId,
                    items: ajaxColums,
                },
            },
            success: res => {
                if (res.success) {
                    let { colsSettingParam } = this.props;
                    let { appcode, pagecode } = colsSettingParam;
                    //removeGlobalStorage('localStorage', this.keySessionS); //在列设置保存之后，移除当页面模板缓存，在重新
                    removeMetaCache(appcode, pagecode);

                    this.onSuccess(metaColumns, successSMG, finalAreaCode);
                }
            },
            error: err => {
                this.onRequestError(err);
            },
        });
    };

    /**
     * 列设置重置或者保存成功以后，更新ncTable和高阶业务表格的column
     */
    onSuccess = (metaColumns, successSMG, areaCode) => {
        let { updateColumnHandle } = this.props;
        this.toCloseDrawer();
        toast({ content: successSMG, light: true });
        updateColumnHandle(metaColumns, areaCode);
    };

    /**
     * 请求失败关闭侧拉、提示错误信息
     */
    onRequestError = err => {
        this.toCloseDrawer();
        console.error(err);
        let msgContent = JSON.stringify(err.message);
        toast({
            color: 'danger',
            content: msgContent,
            mark: 'save-table-columnSetting',
        });
    };

    //点击重置 重置列设置
    onColReset = () => {
        let { colsSettingParam } = this.props;
        let {
            appcode,
            pagecode,
            code,
            pageid,
            areaCode,
            tableType,
            tabName,
            hiddenLeftItem,
        } = colsSettingParam;
        let { json = {} } = this.state;
        // 兼容cardtable多页签
        let finalAreaCode = areaCode;
        if (tableType === 'cardtable' && tabName) {
            finalAreaCode = tabName;
        }
        // 重置列设置也会把列宽重置 添加重置列宽的标识
        // this.resetWidthFlag = true;
        let url = '/nccloud/platform/template/removeUserPropertySettings.do';
        ajax({
            url,
            data: {
                templateId: pageid,
                areaId: finalAreaCode,
            },
            success: res => {
                if (res.success) {
                    ajax({
                        url: '/nccloud/platform/template/getUserTemplateMap.do',
                        data: {
                            appcode,
                            pagecode,
                            templatecode: code,
                            templateId: pageid,
                        },
                        success: result => {
                            //removeGlobalStorage('localStorage', this.keySessionS);
                            removeMetaCache(appcode, pagecode);

                            let areaList = result.data[0].areas;
                            let rightData = result.data[1][finalAreaCode].items;
                            let { userDefineItems } = this.state;
                            let userItems = userDefineItems.map(
                                item => item.attrcode,
                            );
                            let items = areaList[finalAreaCode].items;
                            let metaColums = [];

                            rightData.map(data => {
                                items.map(item => {
                                    if (data.attrcode === item.code) {
                                        let obj = data;
                                        let width = item.width
                                            ? item.width.includes('px')
                                                ? item.width
                                                : item.width + 'px'
                                            : undefined;
                                        obj.width = width;
                                        if (userItems.includes(data.attrcode)) {
                                            obj.visible = true;
                                        }
                                        metaColums.push(obj);
                                    }
                                    return item;
                                });
                                return data;
                            });
                            if (hiddenLeftItem && hiddenLeftItem.length) {
                                metaColums = metaColums.filter(
                                    val =>
                                        !hiddenLeftItem.includes(val.attrcode),
                                );
                            }
                            this.onSuccess(
                                metaColums,
                                json['table_colseting_tip04'],
                                finalAreaCode,
                            );
                        },
                        error: err => {
                            this.onRequestError(err);
                        },
                    });
                }
            },
            error: err => {
                this.onRequestError(err);
            },
        });
    };

    render() {
        const {
            lazyload = true,
            isDrag = true,
            className,
            autoAffixScroll,
            showFoldRow = true,
            adaptionHeight,
            inModal = false,
            isTotal,
            rowKey,
            addBlankCol = true,
            customRowHeight = false, // false时自定义显示行高, 不按照个性化的规则显示行高
            cancelCustomRightMenu = true, // true 不显示保存列宽，重置，列表设置 false 显示保存列宽，重置，列表设置
            data = [], // 数据
            headerHeight, // 自定义表头高度
            bodyClassName,
            bodyDisplayInRow,
            emptyClassName = '',
            footerClassName = '',
            // 仅暂时使用，升级后可以去除
            fixBorder = false,
            // onRow,
        } = this.props;
        const {
            bodyColumn,
            json = {},
            showDrawer,
            displayData,
            sortData,
        } = this.state;
        const ThisTable = lazyload ? BigDataTable : DragTable;
        let {
            tableType = 'standard', // tableType:'compact'紧凑'standard'标准'loose'宽松
            crossCheck = false, // crossCheck 是否斑马线
            cuttingCheck = true, // cuttingCheck 是否分割线
        } = this.nccTable;
        this.freezeColumns(bodyColumn);
        // 判断是否有缓存的customer列的列宽
        this.setCustomerColumnWidthFlag &&
            this.setCustomerColumnWidth(bodyColumn);
        // 列设置图标遮挡最后一列
        !cancelCustomRightMenu && this.resetBodyColumn(addBlankCol, bodyColumn);
        const isMultiHeader = bodyColumn.some(item => item.children);
        showFoldRow && this.autoFoldRow();
        const rowHeight = this.getRowHeight(tableType);

        let height = customRowHeight
            ? {}
            : this.props.height
                ? { height: this.props.height }
                : { height: rowHeight };

        const adaptionHeightParam =
            adaptionHeight || (inModal && this.resizeModal)
                ? {
                    bodyStyle: {
                        height:
                            inModal && !this.state.tableHeight
                                ? 210
                                : this.state.tableHeight,
                    },
                    scroll: { y: this.state.tableHeight },
                    // 这个属性是避免，计算之后页面自动滚动到顶部
                    ignoreScrollYChange: true,
                    // tinper不行 老是出bug 我只能自己处理了 TODO
                    // currentIndex: this.props.currentIndex >= 0 ? this.props.currentIndex : this.state.currentIndex,
                }
                : {};
        let dataLength = this.props.data ? this.props.data.length : 0;
        let handleFooter =
            isTotal && rowKey !== 'total-row' ? this.props.handleFooter : null;
        let dataSource = [];
        if (!rowKey) {
            // 如果没有传入rowKey，数据中没有key字段，增加key字段为唯一标识，避免bee-table白屏
            dataSource = data.map(item => {
                item.key = isWrong(item.key) ? getRandom() : item.key;
                return item;
            });
        } else {
            dataSource = data;
        }

        if (bodyColumn[0] && !bodyDisplayInRow) {
            bodyColumn[0].style = { height: rowHeight, ...height };
        }

        if (!this.state.isEllipsis) {
            height = undefined;
            tableType = '';
        }

        const isEmptyData = !dataSource.length;

        return (
            <div
                onMouseEnter={() => {
                    // 拖拽的过程中离开了表格
                    if (this.draggingBorder) {
                        this.draggingBorder = false;
                        this.table.className = this.table.className.replace(
                            /dragging-border-temp/gi,
                            '',
                        );
                    }
                }}
                onDragOver = { event => {
                    if(event){
                        event.preventDefault && event.preventDefault();
                        event.stopPropagation();
                        if(event.nativeEvent){
                            event.nativeEvent.stopImmediatePropagation();
                        }
                    }         
                }}
                className={classnames({
                    'base-table-wrapper': true,
                    'base-table-bordered': cuttingCheck,
                    'base-table-not-bordered': !cuttingCheck,
                    'base-table-body-word-break': !bodyDisplayInRow,
                    'base-table-data-empty': isEmptyData,
                    'base-table-fix-border': fixBorder,
                })}
            >
                {' '}
                {/* 加这一层的目的是为了处理标准样式border,border直接加bee-table上会导致tinper横向滚动条计算错误*/}
                <ThisTable
                    columnKey="attrcode"
                    loadBuffer={2}
                    dragborder={isDrag}
                    minColumnWidth={45} //解决序号列或者复选框列拖动列宽后无法拖小问题
                    emptyText={this.noData}
                    bodyStyle={{ minHeight: '160px' }}
                    scroll={{
                        //使用悬浮滚动条一定要加这个属性，不然会报错
                        y: 300,
                    }}
                    // onRow={(record, index) => {
                    //     return {
                    //         style: { minHeight: 30 }
                    //     }
                    // }}
                    footer={
                        handleFooter === null
                            ? null
                            : () => handleFooter([...bodyColumn])
                    }
                    {...this.props}
                    bodyClassName={classnames(
                        'base-table-body-scroll-wrapper',
                        bodyClassName,
                    )}
                    footerClassName={classnames(
                        'base-table-footer',
                        footerClassName,
                    )}
                    emptyClassName={`base-table-empty-text  ${emptyClassName}`}
                    // 多表头不能传自定义行高，会影响固定列高度计算
                    headerHeight={isMultiHeader ? undefined : headerHeight}
                    columns={[...bodyColumn]}
                    data={dataSource}
                    className={classnames(
                        'nc-table',
                        'scrollbar-mod',
                        `${tableType}`,
                        {
                            "cross": crossCheck,
                            // "cutting": cuttingCheck,
                            'table-auto-affix': autoAffixScroll,
                            'compatible-browser-fixCol': dataLength < 2,
                            'compatible-browser-body': dataLength === 0,
                            'right-box-shadow': this.state.addRightShadow,
                            'no-right-box-shadow': !this.state.addRightShadow,
                            'multi-table-header': isMultiHeader,
                            'table-has-blank': addBlankCol,
                            'table-show-total': isTotal,
                        },
                        className,
                    )}
                    bordered={cuttingCheck}
                    {...height}
                    ref={dom => {
                        if (dom) {
                            this.table = ReactDOM.findDOMNode(dom);
                            if (this.props.treeTableRef) {
                                this.props.treeTableRef.current = dom;
                            }
                        }
                    }}
                    headerScroll={false}
                    hideHeaderScroll={true}
                    onDraggingBorder={(e, width, column, columns) => {
                        this.onDraggingBorder(e, width, column, columns);
                    }}
                    onDropBorder={(e, width, column, columns) => {
                        this.onDropBorder(e, width, column, columns);
                    }}
                    {...adaptionHeightParam}
                    headerEventNoStop
                />
                {!cancelCustomRightMenu && (
                    <span
                        className="nc-table-col-setting"
                        ref={dom => {
                            if (dom) {
                                this.tableColSettingIcon =
                                    ReactDOM.findDOMNode(dom);
                            }
                        }}
                    >
                        <span className="nc-table-col-setting-shadow"></span>
                        <span className="nc-table-col-setting-bg">
                            <Tooltip
                                delayShow={800}
                                inverse
                                overlay={json['table_colseting_table']}
                                placement="top"
                            >
                                <i
                                    className="iconfont icon-lbsz "
                                    onClick={this.toShowDrawer}
                                />
                            </Tooltip>
                        </span>
                    </span>
                )}
                {showDrawer && (
                    <ColSettingSideBox
                        leftData={displayData}
                        tableScope={this}
                        rightData={sortData}
                        onColsSetting={this.onColsSetting}
                        onColReset={this.onColReset}
                        toCloseDrawer={this.toCloseDrawer}
                    />
                )}
            </div>
        );
    }
}

// Table.SortTable = sort(Table);

// 高阶组件
Table.sort = sort;
Table.location = TableLocation;
Table.bigData = bigData;
Table.dragColumn = dragColumn;
Table.multiSelect = multiSelect;
Table.singleSelect = singleSelect;
Table.sum = sum;
Table.measureScrollbar = measureScrollbar;
Table.filterColumn = filterColumn;
Table.singleFilter = singleFilter;
Table.updateTableHeight = () => {
    PubSub.publish(OTHERCOMPLETE, true);
};

